import React, { FC, ReactNode } from 'react'
import styled, { css } from 'styled-components'

interface ColorOverlayProps {
  active?: boolean
  children: ReactNode
  color?: string
  onMouseOut?: () => void
  onMouseOver?: () => void
}

const ColorOverlayWrapper = styled.div<ColorOverlayProps>`
  position: relative;
  display: block;
  ${({ active, color, theme }) => active && css`
    border-radius: ${theme.borderRadius};
    overflow: hidden;

    &:before {
      content: '';
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
      ${color === 'grey' && css`
        background-color: ${theme.colors.productGreyOverlay};
      `}
    }
  `}
`

export const ColorOverlay: FC<ColorOverlayProps> = (
  {
    active = false,
    children,
    color = 'grey',
    onMouseOut,
    onMouseOver,
  },
) => (
  <ColorOverlayWrapper active={active} color={color} onMouseOut={onMouseOut} onMouseOver={onMouseOver}>
    {children}
  </ColorOverlayWrapper>
)
